export const SET_LIST = 'categories/setList';
export const SET_PAGINATION = 'categories/setPagination';
export const SET_QUERY = 'categories/setQuery';
export const RESET_QUERY = 'categories/resetQuery';
export const SET_LOADING = 'categories/setLoading';
